import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { getInvoiceStatus, moneyFormatter } from '@wayste/client-utils';
import { BanknotesIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../formWrapper/SourSearchWrapper';
import { ErrorBoundary } from './helper/ErrorBoundary';
import { InvoiceStatusPill } from './helper/invoiceStatusPills';
import { ResultWrapper } from './helper/resultWrapper';
export const ReceivableResult = ({ receivable }) => {
    const { invoiceDetails, customerName, customerCompanyName, customerAccountNumber } = receivable;
    const { onNavigate, application, onResetValues } = useContext(CustomFormContext);
    useEffect(() => {
        //console.log('PAYLOAD receivable', receivable);
    }, []);
    const handleRedirect = () => {
        if (application === 'customer-portal') {
            onNavigate(receivable, receivable.id, 'invoices');
            onResetValues('search');
            return;
        }
        onNavigate(receivable, invoiceDetails.orderID, 'billing');
        onResetValues('search');
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(BanknotesIcon, { className: "size-4" }), _jsxs("div", { className: "border-l-2 border-gray-300 pl-2", children: [customerAccountNumber, "-", invoiceDetails.invoiceNumber] }), _jsx("div", { className: "flex flex-col items-center justify-center overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: invoiceDetails !== undefined && invoiceDetails !== null && (_jsx(InvoiceStatusPill, { status: getInvoiceStatus(invoiceDetails) })) }), _jsxs("div", { className: "border-l-2 border-gray-300 pl-2", children: [" ", moneyFormatter(invoiceDetails.total)] }), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: customerCompanyName ? customerCompanyName : customerName })] }) }));
};
//# sourceMappingURL=ReceivableResult.js.map